import React from "react";

export default function Nav() {
  const scrollToForm = (e) => {
    e.preventDefault();
    const el = document.getElementById("formulario");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  return (
    <nav className="nav">
      <div className="nav-brand">
        <span className="dot" />
        <span>
          Climb<span style={{ color: "var(--neon)" }}>uu</span>
        </span>
      </div>
      <a
        href="#formulario"
        className="nav-cta"
        onClick={scrollToForm}
        data-testid="nav-cta"
      >
        Quiero mi plaza
      </a>
    </nav>
  );
}
